import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { ArticlesComponent } from '../articles/articles.component';
import { Title } from '@angular/platform-browser';
import { FilterProductsComponent } from '../filter-products/filter-products.component';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-community-search',
  templateUrl: './community-search.component.html',
  styleUrls: ['./community-search.component.scss'],
})
export class CommunitySearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('Articles') communityArticles: ArticlesComponent;
  @ViewChild('MemberShopProduct') FilterProductsComponent: FilterProductsComponent;

  constructor(private title: Title, private sharedService: SharedService, private router: Router) {

  }
  private destroy$ = new BehaviorSubject<void>(null);

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
  }

  public onMemberShopProductChange(event: any) {
    if (event && event.category && event.subRegion) {
      this.communityArticles.getArticlesList(
        1,
        event.category,
        event.subRegion
      );
      this.FilterProductsComponent.getAds(event.category, event.subRegion);
    } else if (event && event.category) {
      this.communityArticles.getArticlesList(1, event.category, '');
      this.FilterProductsComponent.getAds(event.category, '');
    } else if (event && event.subRegion) {
      this.communityArticles.getArticlesList(1, '', event.subRegion);
      this.FilterProductsComponent.getAds('', event.subRegion);
    }
  }
}
